import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    new_state: [],
    tsm_name: [],
    area_manager: [],
    area_office: [],
    rm: [],
    new_region: [],
    region: [],
    state: [],
    state_office: [],
    dealer_name: [],
    dealer_code: [],
    Product_Line: [],
    lob: [],
    Partner_Type: [],
  },

  submitted: 0,
};

const ManpowerDealerReviewfilterSlice = createSlice({
  name: "ManpowerDealerReviewfilter",
  initialState,
  reducers: {
    addFilters(state, action) {
      state.data = action.payload.data;
      state.submitted = action.payload.submitted;
      // state.fmsNav = action.payload.fmsNav;
    },
    applyFilters(state, action) {
      state.data = action.payload;
    },
    chgSubmitted(state, action) {
      state.submitted = action.payload;
    },
    resetFilters(state) {
      state.data = initialState.data;
      state.submitted = initialState.submitted;
    },
  },
});

export const { addFilters, applyFilters, chgSubmitted, resetFilters } =
  ManpowerDealerReviewfilterSlice.actions;

export default ManpowerDealerReviewfilterSlice.reducer;
 